export const MODULE = 'inventory';